/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-01-11",
    versionChannel: "nightly",
    buildDate: "2025-01-11T00:06:24.257Z",
    commitHash: "8bb90c0c6003a9da00280999c23bbf18bd203a17",
};
